import React from 'react';

interface PlayfairHeadingProps {
    children: React.ReactNode;
    className?: string;
    size?: 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '3xl' | '4xl' | '5xl';
    style?: React.CSSProperties;
}

/**
 * Nobel Aesthetic Component: Playfair Display Heading
 * Usage: Band scores, student names, milestone announcements
 * Style: Playfair Display italic, stone-900
 */
export const PlayfairHeading: React.FC<PlayfairHeadingProps> = ({
    children,
    className = '',
    size = 'xl',
    style
}) => {
    const sizeClasses = {
        'sm': 'text-sm',
        'md': 'text-base',
        'lg': 'text-lg',
        'xl': 'text-xl',
        '2xl': 'text-2xl',
        '3xl': 'text-3xl',
        '4xl': 'text-4xl',
        '5xl': 'text-5xl',
    };

    return (
        <h2 className={`heading-playfair ${sizeClasses[size]} ${className}`} style={style}>
            {children}
        </h2>
    );
};
